import React from "react";
import { ChatEvents, MessageType, Product, Roles } from "../constants";
import HealthAgentMessage from "./Health/AgentMessage";
import TravelAgentMessage from "./Travel/AgentMessage";
import ServiceAgentMessage from "./ServiceBot/AgentMessage";
import HomeAgentMessage from "./Home/AgentMessage";
import TermAgentMessage from "./Term/AgentMessage";
import TermLifeAgentMessage from "./TermLife/AgentMessage";
// import InvestmentAgentMessage from "./Investment/AgentMessage";
import InvestmentAgentMessage from "./Investmentv1/AgentMessage";
import MotorAgentMessage from "./Motor/AgentMessage";
import TwoWheelerAgentMessage from "./TwoWheeler/AgentMessage";


export default function AgentMessage({
  messages,
  agentName,
  sendMessage,
  displayAllOptions,
  GAEvent,
  showPlansComparison,
  regenDoc,
  productId,
  ShowPlanFeatures,
  isService,
  scrollToBottom,
  isHistoryMessgage,
  scrollintoview,
  lastMessage,
  newTermUi,
  roomClosed,
  haveAgentMsg,
  haveTermWaitingMsg,
  setAgentMsgReplied,
  roomId
}) {
  const AgentMsg = messages.length > 0 && messages[messages.length - 1].role && messages[messages.length - 1].role === Roles.Agent ? true : false
  const selectOption = (option, contentType, messageId) => {
    if ((isService && agentName) || roomClosed) {
      return
    }
    option["type"] = contentType;
    let json = {
      content: JSON.stringify(option),
      refMessageId: messageId,
      type: MessageType.json,
    };
    sendMessage(json);
    if (option.key === ChatEvents.RequestCallback) {
      GAEvent({ eventAction: "Call-back", eventLabel: option.display_value })
    }
    else if (option.key === "main menu") {
      GAEvent({ eventAction: "Main-menu", eventLabel: "Main-menu" })
    }
    else if (option.key === "Contact Support") {
      GAEvent({ eventAction: "Contact-Support", eventLabel: "Contact-Support" })
    }
    else {
      GAEvent({ eventAction: "option-selected", eventLabel: option.display_value, issueCode: option?.IssueCode || "", subIssueCode: option?.SubIssueCode || "" })
    }
  };
  const contactSupport = (messageId) => {
    let option = {
      display_value: "Contact Support",
      key: "Contact Support",
      type: "selection"
    }
    let json = {
      content: JSON.stringify(option),
      refMessageId: messageId,
      type: MessageType.json,
    };
    sendMessage(json);
  }
  const mainMenu = (messageId) => {
    let option = {
      display_value: "Main Menu",
      key: "main menu",
      type: "selection"
    }
    let json = {
      content: JSON.stringify(option),
      refMessageId: messageId,
      type: MessageType.json,
    };
    sendMessage(json);

  };
  const ViewPlanDetails = (plans_info, messageId) => {
    let resp = { "plan": [plans_info], "type": "plan_selection" }
    let json = {
      content: JSON.stringify(resp),
      refMessageId: messageId,
      type: MessageType.json,
    };
    sendMessage(json);
    GAEvent({ eventAction: "plans-card-view-feature", eventLabel: plans_info.plan_name })
  }
  return (
    <>
      {productId === Product.Health && !isService ?
        <HealthAgentMessage
          messages={messages}
          agentName={agentName}
          displayAllOptions={displayAllOptions}
          GAEvent={GAEvent}
          showPlansComparison={showPlansComparison}
          regenDoc={regenDoc}
          selectOption={selectOption}
          contactSupport={contactSupport}
          mainMenu={mainMenu}
          AgentMsg={AgentMsg}
          ViewPlanDetails={ViewPlanDetails}
          ShowPlanFeatures={ShowPlanFeatures}
        /> : null}
      {productId === Product.Travel && !isService ?
        <TravelAgentMessage
          messages={messages}
          agentName={agentName}
          displayAllOptions={displayAllOptions}
          GAEvent={GAEvent}
          showPlansComparison={showPlansComparison}
          regenDoc={regenDoc}
          selectOption={selectOption}
          contactSupport={contactSupport}
          mainMenu={mainMenu}
          AgentMsg={AgentMsg}
          ViewPlanDetails={ViewPlanDetails}
          ShowPlanFeatures={ShowPlanFeatures}
        /> : null}
      {productId === Product.Investment && !isService ?
        <InvestmentAgentMessage
          messages={messages}
          agentName={agentName}
          displayAllOptions={displayAllOptions}
          GAEvent={GAEvent}
          showPlansComparison={showPlansComparison}
          regenDoc={regenDoc}
          selectOption={selectOption}
          contactSupport={contactSupport}
          mainMenu={mainMenu}
          AgentMsg={AgentMsg}
          ViewPlanDetails={ViewPlanDetails}
          ShowPlanFeatures={ShowPlanFeatures}
          scrollToBottom={scrollToBottom}
          isHistoryMessgage={isHistoryMessgage}
          scrollintoview={scrollintoview}
          lastMessage={lastMessage}
          roomClosed={roomClosed}
          haveAgentMsg={haveAgentMsg}
          haveTermWaitingMsg={haveTermWaitingMsg}
        /> : null}

      {isService ?
        <ServiceAgentMessage
          messages={messages}
          agentName={agentName}
          displayAllOptions={displayAllOptions}
          GAEvent={GAEvent}
          showPlansComparison={showPlansComparison}
          regenDoc={regenDoc}
          selectOption={selectOption}
          contactSupport={contactSupport}
          mainMenu={mainMenu}
          AgentMsg={AgentMsg}
          ViewPlanDetails={ViewPlanDetails}
          ShowPlanFeatures={ShowPlanFeatures}
          scrollToBottom={scrollToBottom}
          isHistoryMessgage={isHistoryMessgage}
          scrollintoview={scrollintoview}
          lastMessage={lastMessage}
          setAgentMsgReplied={setAgentMsgReplied}
          roomId={roomId}
        /> :
        null}
      {productId === Product.Home && !isService ?
        <HomeAgentMessage
          messages={messages}
          agentName={agentName}
          displayAllOptions={displayAllOptions}
          GAEvent={GAEvent}
          showPlansComparison={showPlansComparison}
          regenDoc={regenDoc}
          selectOption={selectOption}
          contactSupport={contactSupport}
          mainMenu={mainMenu}
          AgentMsg={AgentMsg}
          ViewPlanDetails={ViewPlanDetails}
          ShowPlanFeatures={ShowPlanFeatures}
        /> : null}
      {productId === Product.Term && !isService && newTermUi ?
          <TermLifeAgentMessage
          messages={messages}
          agentName={agentName}
          displayAllOptions={displayAllOptions}
          GAEvent={GAEvent}
          showPlansComparison={showPlansComparison}
          regenDoc={regenDoc}
          selectOption={selectOption}
          contactSupport={contactSupport}
          mainMenu={mainMenu}
          AgentMsg={AgentMsg}
          ViewPlanDetails={ViewPlanDetails}
          ShowPlanFeatures={ShowPlanFeatures}
          scrollToBottom={scrollToBottom}
          roomClosed={roomClosed}
          haveAgentMsg={haveAgentMsg}
          haveTermWaitingMsg={haveTermWaitingMsg}
        /> : null}
      {productId === Product.Term && !isService && !newTermUi ?
        <TermAgentMessage
            messages={messages}
            agentName={agentName}
            displayAllOptions={displayAllOptions}
            GAEvent={GAEvent}
            showPlansComparison={showPlansComparison}
            regenDoc={regenDoc}
            selectOption={selectOption}
            contactSupport={contactSupport}
            mainMenu={mainMenu}
            AgentMsg={AgentMsg}
            ViewPlanDetails={ViewPlanDetails}
            ShowPlanFeatures={ShowPlanFeatures}
            scrollToBottom={scrollToBottom}
        /> : null}
      {(productId === Product.Motor ||  productId === Product.CommercialVehicle) && !isService ?
        <MotorAgentMessage
          messages={messages}
          agentName={agentName}
          displayAllOptions={displayAllOptions}
          GAEvent={GAEvent}
          showPlansComparison={showPlansComparison}
          regenDoc={regenDoc}
          selectOption={selectOption}
          contactSupport={contactSupport}
          mainMenu={mainMenu}
          AgentMsg={AgentMsg}
          ViewPlanDetails={ViewPlanDetails}
          ShowPlanFeatures={ShowPlanFeatures}
          scrollToBottom={scrollToBottom}
          isHistoryMessgage={isHistoryMessgage}
          scrollintoview={scrollintoview}
          lastMessage={lastMessage}
        /> : null}
      {productId === Product.Twowheeler && !isService ?
        <TwoWheelerAgentMessage
          messages={messages}
          agentName={agentName}
          displayAllOptions={displayAllOptions}
          GAEvent={GAEvent}
          showPlansComparison={showPlansComparison}
          regenDoc={regenDoc}
          selectOption={selectOption}
          contactSupport={contactSupport}
          mainMenu={mainMenu}
          AgentMsg={AgentMsg}
          ViewPlanDetails={ViewPlanDetails}
          ShowPlanFeatures={ShowPlanFeatures}
        /> : null}
    </>
  );
}
